module.exports = __webpack_public_path__ + "static/media/dsc-01.d4671c46.jpg";